import { render, staticRenderFns } from "./MatterDimensionsTab.vue?vue&type=template&id=d3066bb2&"
import script from "./MatterDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./MatterDimensionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports